
        var result = require("!!../../../../node_modules/css-loader/index.js!./navmenu.component.css");

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    


//////////////////
// WEBPACK FOOTER
// ./ClientApp/app/components/navmenu/navmenu.component.css
// module id = 25
// module chunks = 0